module.exports = __webpack_public_path__ + "static/logo-af01e33d873e4fcaf56b8c86737bb43f.svg";